import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a view for filtering products by bet shop.
 * @extends JetView
 */
export default class FilterProductsThirdByBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
            ],
        };

        // Center left section containing product selection combo
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProductsThird',
                    id: 'ProductsThird',
                    label: _('Producto Terceros'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Center right section containing activation status selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the main layout
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section with actions for adding, clearing, and consulting
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir'),
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('betShopReportsProductsThirdAdd', 'Add'),
                    css: 'prm-betShopReportsProductsThirdAdd',
                    click: () => {
                        this.app.callEvent('addProductsThird:button', [{}]);
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        this.app.callEvent('productsThird:filter', [filterdata]);
                        $$('b5').collapse();
                    },
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and fetches data for the product selection.
     */
    init() {
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text);
                    $$('ProductsThird').define('options', resp.Data);
                    $$('ProductsThird').refresh();
                },
            });
    }
}

// FILE DOCUMENTED
